module.exports = ".member-name {\r\n  color: cornflowerblue;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/clubprogram-reports/components/sponsorship-report/sponsorship-report.component.css
// module id = ./src/app/shared/clubprogram-reports/components/sponsorship-report/sponsorship-report.component.css
// module chunks = main